export default "__VITE_ASSET__BeaA1ve3__"